import api from './api';

/**
 * Servicio para enviar logs al backend
 */
class LogService {
  /**
   * Envía un log al backend de forma asíncrona
   * No bloquea la UI si falla
   * @param {object} logObject - Objeto de log estructurado
   */
  async sendLog(logObject) {
    try {
      await api.post('/logs/frontend', logObject);
    } catch (error) {
      console.error('Error enviando log al backend:', error);
    }
  }
}

const logService = new LogService();

export default logService;